/* eslint-disable import/first */

import {
  Archive,
  BarChart,
  Edit,
  Layers,
  List,
  Package,
  Sliders,
  Users,
  Info,
} from "react-feather";

import ApplicationEditPage from "../pages/ApplicationsEdit/ApplicationEditPage";
import ApplicationKinds from "../pages/paremeters/application kinds";
import ApplicationStatus from "../pages/paremeters/application status";
import ApplicationsEdit from "../pages/ApplicationsEdit";
import ApplicationsHistory from "../pages/ApplicationsHistory/index";
import DefaultEmployee from "../pages/dashboards/DefaultEmployee";
import DefaultManager from "../pages/dashboards/DefaultManager";
import DiplomaKinds from "../pages/paremeters/diploma kinds";
import { DirectionsBoat } from "@material-ui/icons";
import Documents from "../pages/paremeters/documents";
import DocumentsCategories from "../pages/paremeters/documents categories";
import DocumentsPerKind from "../pages/paremeters/documents per kind";
import EditApplication from "../pages/external user/editApplication/EditApplication";
import { Email } from "@material-ui/icons";
import Emails from "../pages/emails";
import ExternalSignIn from "../pages/auth/ExternalSignIn";
import ExternalUserAuthGuard from "../components/ExternalUserAuthGuard";
import ExternalUserDashBoard from "../pages/external user/externalUserDashBoard";
import FlowApplicationStatus from "../pages/paremeters/flow application status";
import GeographicalDepartments from "../pages/paremeters/geographical departments";
import GeographicalDepartmentsTypes from "../pages/paremeters/geographical departments types";
import GuestGuard from "../components/GuestGuard";
import InternalSignIn from "../pages/auth/InternalSignIn";
import LandingPage from "../pages/landingPage/LandingPage";
import LeaveReasons from "../pages/paremeters/leave reasons";
import MailTemplates from "../pages/paremeters/mail templates";
import NewApplication from "../pages/external user/new application";
import MyApplications from "../pages/external user/my applications";
// import Page404 from "../pages/auth/Page404";
import Page404 from "../components/GovGr404Page";
import PortAuthorities from "../pages/paremeters/port authorities";
import Ports from "../pages/paremeters/ports";
import React from "react";
import ReferralKinds from "../pages/paremeters/referral kinds";
import ResetPassword from "../pages/auth/ResetPassword";
import SailorSpecializations from "../pages/paremeters/sailor specializations";
import Sailors from "../pages/NauticalCrewList/Sailors";
import Sectors from "../pages/paremeters/sectors";
import Settings from "../pages/paremeters/settings";
import ShipConfig from "../pages/NauticalCrewList/Ships/Ship config";
import ShipData from "../pages/NauticalCrewList/Ships/Ship Data";
import ShipHeader from "../pages/NauticalCrewList/Ships/Ship Record Header";
import ShipRecordDetails from "../pages/NauticalCrewList/Ships/Ship Record Details";
import Ships from "../pages/NauticalCrewList/Ships";
import SignUp from "../pages/auth/SignUp";
import UserAuthGuard0 from "../components/UserAuthGuard0";
import UserAuthGuard1 from "../components/UserAuthGuard1";
import UserAuthGuard2 from "../components/UserAuthGuard2";
import UserStatistics from "../pages/UserStatistics";
import async from "../components/Async";
import ApplicationInfo from "../pages/external user/applications info";
import ApplicationsSummary from "../pages/ApplicationsSummary";
import InternalCallback from "../pages/auth/InternalCallback";
import ExternalCallback from "../pages/auth/ExternalCallback";
import GovGrAccordion from "../components/GovGrAccordion";
import GovGr500Page from "../components/GovGr500Page";
import AmkaVerification from "../pages/external user/externalUserDashBoard/AmkaVerification";
import GdprPage from "../pages/external user/externalUserDashBoard/GdprPage";

import Login from "../pages/auth/login";
import GovGr500PageWrapper from "../components/GovGr500Page/GovGr500PageWrapper";
import UserAuthGuard4 from "../components/UserAuthGuard4";
const Default = async(() => import("../pages/dashboards/Default"));
//const DefaultManager = async(() => import("../pages/dashboards/Default"))

// Admin
const dashboardsRoutesAdmin = {
  id: "Dashboard",
  path: "/",
  header: null,
  icon: <Sliders />,
  containsHome: true,
  children: null,
  component: Default,
  guard: UserAuthGuard0,
};

const nauticalCrewListRoutesAdmin = {
  id: "Nautical Crew List",
  path: "/nauticalcrewlist",
  header: null,
  icon: <DirectionsBoat />,
  containsHome: true,
  guard: UserAuthGuard0,
  children: [
    {
      path: "/nauticalcrewlist/sailors",
      name: "Sailors",
      component: Sailors,
      guard: UserAuthGuard0,
    },
    {
      path: "/nauticalcrewlist/ship",
      name: "Ships",
      component: Ships,
      guard: UserAuthGuard0,
    },
  ],
};

const shipDataRoutesAdmin = {
  id: "Edit Applications",
  path: "/nauticalcrewlist/ship/:id",
  component: ShipData,
  guard: UserAuthGuard0,
};

const shipRecordHdRoutesAdmin = {
  id: "Edit Applications",
  path: "/nauticalcrewlist/shiprecordhd/:id",
  component: ShipHeader,
  guard: UserAuthGuard0,
};

const shipRecordRoutesAdmin = {
  id: "Edit Applications",
  path: "/nauticalcrewlist/shiprecord/:id",
  component: ShipRecordDetails,
  guard: UserAuthGuard0,
};

const shipConfigRoutesAdmin = {
  id: "Ship Configuration",
  path: "/nauticalcrewlist/shipconfig/:id",
  component: ShipConfig,
  guard: UserAuthGuard0,
};

const applicationsRoutesAdmin = {
  id: "Edit Applications",
  path: "/editApplications",
  header: null,
  icon: <Edit />,
  containsHome: true,
  children: null,
  component: ApplicationsEdit,
  guard: UserAuthGuard0,
};

const userStatisticsRoutesAdmin = {
  id: "User statistics",
  path: "/userStatistics",
  header: null,
  icon: <BarChart />,
  containsHome: false,
  children: null,
  component: UserStatistics,
  guard: UserAuthGuard0,
};

const applicationsSummaryRoutesAdmin = {
  id: "Applications Summary",
  path: "/applicationsSummary",
  header: null,
  icon: <BarChart />,
  containsHome: false,
  children: null,
  component: ApplicationsSummary,
  guard: UserAuthGuard0,
};

const applicationsHistoryRoutesAdmin = {
  id: "Applications History",
  path: "/applicationsHistory",
  header: null,
  icon: <Archive />,
  containsHome: true,
  children: null,
  component: ApplicationsHistory,
  guard: UserAuthGuard0,
};

const applicationEditRouteAdmin = {
  id: "Edit Applications",
  path: "/editApplications/application/",
  header: null,
  icon: <Edit />,
  containsHome: true,
  children: null,
  component: ApplicationEditPage,
  guard: UserAuthGuard0,
};

const dashboardNauticalParameterRoutesAdmin = {
  id: "Nautical parameters",
  path: "/nautical-parameters",
  header: null,
  icon: <Package />,
  containsHome: true,
  guard: UserAuthGuard0,
  children: [
    {
      path: "/nautical-parameters/certificationKinds",
      name: "Diploma Kinds",
      component: DiplomaKinds,
      guard: UserAuthGuard0,
    },
    {
      path: "/nautical-parameters/leavereasons",
      name: "Leave Reasons",
      component: LeaveReasons,
      guard: UserAuthGuard0,
    },
    {
      path: "/nautical-parameters/sailorspecializations",
      name: "Sailor Specializations",
      component: SailorSpecializations,
      guard: UserAuthGuard0,
    },
    {
      path: "/nautical-parameters/ports",
      name: "Ports",
      component: Ports,
      guard: UserAuthGuard0,
    },
  ],
};

const dashboardsParameterRoutesAdmin = {
  id: "Application parameters",
  path: "/parameters",
  header: null,
  icon: <Layers />,
  containsHome: true,
  guard: UserAuthGuard0,
  children: [
    {
      path: "/parameters/prfcs",
      name: "Geographical Departments",
      component: GeographicalDepartments,
      guard: UserAuthGuard0,
    },
    {
      path: "/parameters/prfcsTypes",
      name: "Geographical Departments Types",
      component: GeographicalDepartmentsTypes,
      guard: UserAuthGuard0,
    },
    {
      path: "/parameters/portAuthorities",
      name: "Port Authorities",
      component: PortAuthorities,
      guard: UserAuthGuard0,
    },
    {
      path: "/parameters/docCategories",
      name: "Document Categories",
      component: DocumentsCategories,
      guard: UserAuthGuard0,
    },
    {
      path: "/parameters/documents",
      name: "Documents",
      component: Documents,
      guard: UserAuthGuard0,
    },
    {
      path: "/parameters/applKinds",
      name: "Application Kinds",
      component: ApplicationKinds,
      guard: UserAuthGuard0,
    },
    {
      path: "/parameters/docPerKind",
      name: "Documents per Kind",
      component: DocumentsPerKind,
      guard: UserAuthGuard0,
    },
    {
      path: "/parameters/applStatus",
      name: "Applications Status",
      component: ApplicationStatus,
      guard: UserAuthGuard0,
    },
    // {
    //   path: "/parameters/flowApplStatus",
    //   name: "Flow Application Status",
    //   component: FlowApplicationStatus,
    //   guard: UserAuthGuard0,
    // },
    {
      path: "/parameters/referralKinds",
      name: "Referral Kinds",
      component: ReferralKinds,
      guard: UserAuthGuard0,
    },
    {
      path: "/parameters/mailTemplates",
      name: "Mail Templates",
      component: MailTemplates,
      guard: UserAuthGuard0,
    },
    {
      path: "/parameters/sectors",
      name: "Sectors",
      component: Sectors,
      guard: UserAuthGuard0,
    },
    {
      path: "/parameters/settings",
      name: "Settings",
      component: Settings,
      guard: UserAuthGuard0,
    },
  ],
  component: null,
};

const emailRoutesAdmin = {
  id: "Emails",
  path: "/emails",
  header: null,
  icon: <Email />,
  containsHome: false,
  children: null,
  component: Emails,
  guard: UserAuthGuard0,
};

// Manager
const dashboardsRoutesManager = {
  id: "Dashboard",
  path: "/",
  header: null,
  icon: <Sliders />,
  containsHome: true,
  children: null,
  component: DefaultManager,
  guard: UserAuthGuard1,
};

const applicationsRoutesManager = {
  id: "Edit Applications",
  path: "/editApplications",
  header: null,
  icon: <Edit />,
  containsHome: true,
  children: null,
  component: ApplicationsEdit,
  guard: UserAuthGuard1,
};
const applicationsHistoryRoutesManager = {
  id: "Applications History",
  path: "/applicationsHistory",
  header: null,
  icon: <Archive />,
  containsHome: true,
  children: null,
  component: ApplicationsHistory,
  guard: UserAuthGuard1,
};

const nauticalCrewListRoutesManager = {
  id: "Nautical Crew List",
  path: "/nauticalcrewlist",
  header: null,
  icon: <DirectionsBoat />,
  containsHome: true,
  guard: UserAuthGuard1,
  children: [
    {
      path: "/nauticalcrewlist/sailors",
      name: "Sailors",
      component: Sailors,
      guard: UserAuthGuard1,
    },
    {
      path: "/nauticalcrewlist/ship",
      name: "Ships",
      component: Ships,
      guard: UserAuthGuard1,
    },
  ],
};

const shipDataRoutesManager = {
  id: "Edit Applications",
  path: "/nauticalcrewlist/ship/:id",
  component: ShipData,
  guard: UserAuthGuard1,
};

const shipRecordHdRoutesManager = {
  id: "Edit Applications",
  path: "/nauticalcrewlist/shiprecordhd/:id",
  component: ShipHeader,
  guard: UserAuthGuard1,
};

const shipRecordRoutesManager = {
  id: "Edit Applications",
  path: "/nauticalcrewlist/shiprecord/:id",
  component: ShipRecordDetails,
  guard: UserAuthGuard1,
};

const shipConfigRoutesManager = {
  id: "Ship Configuration",
  path: "/nauticalcrewlist/shipconfig/:id",
  component: ShipConfig,
  guard: UserAuthGuard1,
};

const applicationEditRouteManager = {
  id: "Edit Applications",
  path: "/editApplications/application/",
  header: null,
  icon: <Edit />,
  containsHome: true,
  children: null,
  component: ApplicationEditPage,
  guard: UserAuthGuard1,
};

const userStatisticsRoutesManager = {
  id: "User statistics",
  path: "/userStatistics",
  header: null,
  icon: <BarChart />,
  containsHome: false,
  children: null,
  component: UserStatistics,
  guard: UserAuthGuard1,
};

const emailRoutesManager = {
  id: "Emails",
  path: "/emails",
  header: null,
  icon: <Email />,
  containsHome: false,
  children: null,
  component: Emails,
  guard: UserAuthGuard1,
};

// Employee
const dashboardsRoutesEmployee = {
  id: "Dashboard",
  path: "/",
  header: null,
  icon: <Sliders />,
  containsHome: true,
  children: null,
  component: DefaultEmployee,
  guard: UserAuthGuard2,
};

const applicationsRoutesEmployee = {
  id: "Edit Applications",
  path: "/editApplications",
  header: null,
  icon: <Edit />,
  containsHome: true,
  children: null,
  component: ApplicationsEdit,
  guard: UserAuthGuard2,
};

const applicationsHistoryRoutesEmployee = {
  id: "Applications History",
  path: "/applicationsHistory",
  header: null,
  icon: <Archive />,
  containsHome: true,
  children: null,
  component: ApplicationsHistory,
  guard: UserAuthGuard2,
};

const nauticalCrewListRoutesEmployee = {
  id: "Nautical Crew List",
  path: "/nauticalcrewlist",
  header: null,
  icon: <DirectionsBoat />,
  containsHome: true,
  guard: UserAuthGuard2,
  children: [
    {
      path: "/nauticalcrewlist/sailors",
      name: "Sailors",
      component: Sailors,
      guard: UserAuthGuard2,
    },
    {
      path: "/nauticalcrewlist/ship",
      name: "Ships",
      component: Ships,
      guard: UserAuthGuard2,
    },
  ],
};

const shipDataRoutesEmployee = {
  id: "Edit Applications",
  path: "/nauticalcrewlist/ship/:id",
  component: ShipData,
  guard: UserAuthGuard2,
};

const shipRecordHdRoutesEmployee = {
  id: "Edit Applications",
  path: "/nauticalcrewlist/shiprecordhd/:id",
  component: ShipHeader,
  guard: UserAuthGuard2,
};

const shipRecordRoutesEmployee = {
  id: "Edit Applications",
  path: "/nauticalcrewlist/shiprecord/:id",
  component: ShipRecordDetails,
  guard: UserAuthGuard2,
};

const shipConfigRoutesEmployee = {
  id: "Ship Configuration",
  path: "/nauticalcrewlist/shipconfig/:id",
  component: ShipConfig,
  guard: UserAuthGuard2,
};

const applicationEditRouteEmployee = {
  id: "Edit Applications",
  path: "/editApplications/application/",
  header: null,
  icon: <Edit />,
  containsHome: true,
  children: null,
  component: ApplicationEditPage,
  guard: UserAuthGuard2,
};

const userStatisticsRoutesEmployee = {
  id: "User statistics",
  path: "/userStatistics",
  header: null,
  icon: <BarChart />,
  containsHome: false,
  children: null,
  component: UserStatistics,
  guard: UserAuthGuard2,
};

const emailRoutesEmployee = {
  id: "Emails",
  path: "/emails",
  header: null,
  icon: <Email />,
  containsHome: false,
  children: null,
  component: Emails,
  guard: UserAuthGuard2,
};

// Viewer
const dashboardsRoutesViewer = {
  id: "Dashboard",
  path: "/",
  header: null,
  icon: <Sliders />,
  containsHome: true,
  children: null,
  component: () => <></>,
  guard: UserAuthGuard4,
};

const applicationEditRouteViewer = {
  id: "Edit Applications",
  path: "/editApplications/application/",
  header: null,
  icon: <Edit />,
  containsHome: true,
  children: null,
  component: ApplicationEditPage,
  guard: UserAuthGuard4,
};

const applicationsRoutesViewer = {
  id: "Edit Applications",
  path: "/editApplications",
  header: null,
  icon: <Edit />,
  containsHome: true,
  children: null,
  component: ApplicationsEdit,
  guard: UserAuthGuard4,
};

// External user
const dashboardsRoutesExternalUser = {
  id: "Dashboard",
  path: "/",
  header: null,
  icon: <Sliders />,
  containsHome: true,
  children: null,
  component: ExternalUserDashBoard,
  guard: ExternalUserAuthGuard,
};

const GdprVerificationExternalUser = {
  id: "Gdpr Page",
  path: "/gdprpage",
  header: null,
  icon: <Sliders />,
  containsHome: true,
  children: null,
  component: GdprPage,
  guard: ExternalUserAuthGuard,
};

const amkaVerificationExternalUser = {
  id: "Amka Verification Page",
  path: "/amkaverification",
  header: null,
  icon: <Sliders />,
  containsHome: true,
  children: null,
  component: AmkaVerification,
  guard: ExternalUserAuthGuard,
};

const externalUserApplications = {
  id: "My applications",
  path: "/my-applications",
  header: null,
  icon: <List />,
  containsHome: false,
  children: null,
  component: MyApplications,
  guard: ExternalUserAuthGuard,
};

const externalUserApplication = {
  id: "New application",
  path: "/new-application/:id/:forMe",
  header: null,
  icon: <Edit />,
  containsHome: false,
  children: null,
  component: NewApplication,
  guard: ExternalUserAuthGuard,
};

const externalUserApplicationEdit = {
  id: "Edit Applications",
  path: "/editApplications/application",
  header: null,
  icon: <Edit />,
  containsHome: true,
  children: null,
  component: EditApplication,
  guard: ExternalUserAuthGuard,
};

const externalUserApplicationInfo = {
  id: "Application Info",
  path: "/applicationInfo",
  header: null,
  icon: <Info />,
  containsHome: true,
  children: null,
  component: ApplicationInfo,
  guard: ExternalUserAuthGuard,
};

const externalUserBlankPage = {
  id: "Blank Page",
  path: "/blankpage",
  header: null,
  icon: <Info />,
  containsHome: true,
  children: null,
  component: GovGrAccordion,
  guard: ExternalUserAuthGuard,
};

const internalUserApplicationInfo = {
  id: "Application Info",
  path: "/applicationInfo",
  header: null,
  icon: <Info />,
  containsHome: true,
  children: null,
  component: ApplicationInfo,
  // guard: UserAuthGuard0,
};

const GovGr500PageError = {
  id: "GovGr500Page",
  path: "/500",
  header: null,
  icon: <Info />,
  containsHome: true,
  children: null,
  component: GovGr500PageWrapper,
  // guard: UserAuthGuard0,
};

const landingPage = {
  id: "Welcome",
  path: "/",
  icon: <Users />,
  component: LandingPage,
};

const authRoutes = {
  id: "Auth",
  path: "/auth",
  icon: <Users />,
  children: [
    {
      path: "/auth/login/:applKindId/:forMe",
      name: "Login",
      component: Login,
    },
    {
      path: "/auth/login",
      name: "Login",
      component: Login,
    },
    {
      path: "/auth/i-sign-in",
      name: "Sign In",
      component: InternalSignIn,
    },
    {
      path: "/auth/e-sign-in",
      name: "Sign In",
      component: ExternalSignIn,
    },
    {
      path: "/auth/internalcallback",
      name: "Redirect callback",
      component: InternalCallback,
    },
    {
      path: "/auth/externalcallback",
      name: "Taxis redirect callback",
      component: ExternalCallback,
    },
    {
      path: "/auth/e-callback",
      name: "Taxis redirect callback",
      component: ExternalCallback,
    },
    {
      path: "/auth/sign-up",
      name: "Sign Up",
      component: SignUp,
      guard: GuestGuard,
    },
    {
      path: "/auth/reset-password",
      name: "Reset Password",
      component: ResetPassword,
      guard: GuestGuard,
    },
    {
      path: "/auth/404",
      name: "404 Page",
      component: Page404,
    },
    {
      path: "/auth/500",
      name: "500 Page",
      component: GovGr500Page,
    },
  ],
  component: null,
};

// Routes using the Dashboard layout for admins
export const dashboardLayoutRoutesAdmin = [
  dashboardsRoutesAdmin,
  nauticalCrewListRoutesAdmin,
  shipDataRoutesAdmin,
  shipRecordHdRoutesAdmin,
  shipRecordRoutesAdmin,
  applicationsRoutesAdmin,
  applicationsHistoryRoutesAdmin,
  dashboardsParameterRoutesAdmin,
  dashboardNauticalParameterRoutesAdmin,
  applicationEditRouteAdmin,
  userStatisticsRoutesAdmin,
  emailRoutesAdmin,
  shipConfigRoutesAdmin,
  internalUserApplicationInfo,
  applicationsSummaryRoutesAdmin,
  GovGr500PageError,
];

// Routes using the Dashboard layout for managers
export const dashboardLayoutRoutesManager = [
  dashboardsRoutesManager,
  nauticalCrewListRoutesManager,
  shipDataRoutesManager,
  shipRecordHdRoutesManager,
  shipRecordRoutesManager,
  applicationsRoutesManager,
  applicationEditRouteManager,
  applicationsHistoryRoutesManager,
  userStatisticsRoutesManager,
  emailRoutesManager,
  shipConfigRoutesManager,
  internalUserApplicationInfo,
  GovGr500PageError,
];

// Routes using the Dashboard layout for employees
export const dashboardLayoutRoutesEmployee = [
  dashboardsRoutesEmployee,
  nauticalCrewListRoutesEmployee,
  shipDataRoutesEmployee,
  shipRecordHdRoutesEmployee,
  shipRecordRoutesEmployee,
  applicationsRoutesEmployee,
  applicationEditRouteEmployee,
  applicationsHistoryRoutesEmployee,
  userStatisticsRoutesEmployee,
  emailRoutesEmployee,
  shipConfigRoutesEmployee,
  internalUserApplicationInfo,
  GovGr500PageError,
];

// Routes using the Dashboard layout for external users
export const dashboardLayoutRoutesExternalUser = [
  dashboardsRoutesExternalUser,
  externalUserApplications,
  externalUserApplication,
  externalUserApplicationEdit,
  externalUserApplicationInfo,
  amkaVerificationExternalUser,
  GdprVerificationExternalUser,
  GovGr500PageError,
];

// Routes using the Dashboard layout for Viewers
export const dashboardLayoutRoutesViewer = [
  dashboardsRoutesViewer,
  applicationsRoutesViewer,
  applicationEditRouteViewer,
];

// Routes using the Auth layout
export const authLayoutRoutes = [authRoutes, landingPage];

// Routes visible in the sidebar
export const sidebarRoutes = {
  admin: [
    dashboardsRoutesAdmin,
    internalUserApplicationInfo,
    nauticalCrewListRoutesAdmin,
    applicationsRoutesAdmin,
    applicationsHistoryRoutesAdmin,
    dashboardsParameterRoutesAdmin,
    dashboardNauticalParameterRoutesAdmin,
    userStatisticsRoutesAdmin,
    applicationsSummaryRoutesAdmin,
    emailRoutesAdmin,
  ],
  manager: [
    dashboardsRoutesManager,
    internalUserApplicationInfo,
    nauticalCrewListRoutesManager,
    applicationsRoutesManager,
    applicationsHistoryRoutesManager,
    userStatisticsRoutesManager,
    emailRoutesManager,
  ],
  employee: [
    dashboardsRoutesEmployee,
    internalUserApplicationInfo,
    nauticalCrewListRoutesEmployee,
    applicationsRoutesEmployee,
    applicationsHistoryRoutesEmployee,
    userStatisticsRoutesEmployee,
    emailRoutesEmployee,
  ],
  viewer: [dashboardsRoutesViewer, applicationsRoutesViewer],
  externalUser: [
    dashboardsRoutesExternalUser,
    externalUserApplications,
    externalUserApplicationInfo,
  ],
};
